import Head from 'next/head';
import 'animate.css';
import { Footer, Header } from '../../components';
import KetoPage from './keto-page';
import menu from '../../utils/menu';

export default function FitKonnekt() {
  return (
    <>
      <Head>
        <title>
          Keto: Unlocking the Power of Ketogenic Diet for Effective Weight Loss
          and Health
        </title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Bellota:wght@400;700&display=swap"
          rel="stylesheet"
        />
        <meta
          property="og:title"
          content="Keto: Unlocking the Power of Ketogenic Diet for Effective Weight Loss
          and Health"
        />

        <meta
          property="og:image:alt"
          content="Keto: Unlocking the Power of Ketogenic Diet for Effective Weight Loss
          and Health"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="A complete guide to the ketogenic diet for weight reduction and health. Discover the ketogenic diet's low-carb, high-fat approach to ketosis. Keto may improve metabolic health, energy, mental clarity, and weight reduction. Learn ketogenic meal planning, recipes, and lifestyle suggestions. Use Keto for weight reduction and wellness."
        />
        <meta
          name="description"
          content="A complete guide to the ketogenic diet for weight reduction and health. Discover the ketogenic diet's low-carb, high-fat approach to ketosis. Keto may improve metabolic health, energy, mental clarity, and weight reduction. Learn ketogenic meal planning, recipes, and lifestyle suggestions. Use Keto for weight reduction and wellness."
        />
        <meta
          name="keywords"
          content="Keto, ketogenic diet, weight loss, low-carb, high-fat foods, ketosis, increased energy, mental clarity, metabolic health, meal planning, recipe ideas, ketogenic lifestyle, weight loss goals, health goals, Mavinx health and wellness guide"
        />
      </Head>
      <Header
        appearance="transparent"
        appearanceLogo="keto"
        appearanceNav="keto"
        menu={menu}
      />
      <KetoPage />
      <Footer line="keto" logo="keto" variant="keto" />
    </>
  );
}
